export default class FileUploadNotStartedError extends Error {}
